import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const generateData = () => {
  const ageSegments = ['10-19', '20-29', '30-39', '40-49', '50-59', '60+'];
  const data = [];

  for (let i = 0; i < 24; i++) {
    const hour = i.toString().padStart(2, '0');
    const isNightHour = i >= 22 || i < 6;
    const isPeakHour = i >= 9 && i < 17;
    
    const entry = { time: `${hour}:00` };
    
    ageSegments.forEach(segment => {
      const baseValue = isNightHour ? Math.floor(Math.random() * 5) :
                        isPeakHour ? Math.floor(Math.random() * 30) + 20 :
                        Math.floor(Math.random() * 20) + 10;
      
      // Adjust values based on age segment (younger segments slightly higher)
      const adjustmentFactor = 1 - (ageSegments.indexOf(segment) * 0.1);
      entry[segment] = Math.floor(baseValue * adjustmentFactor);
    });
    
    data.push(entry);
  }
  return data;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip bg-white border border-gray-300 p-2 rounded shadow">
        <p className="label font-bold">{`Time: ${label}`}</p>
        {payload.map((entry, index) => (
          <p key={index} style={{ color: entry.color }}>
            {`${entry.name}: ${entry.value}`}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const AgeSegmentLineChart = () => {
  const data = generateData();
  const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F06292'];

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        {['10-19', '20-29', '30-39', '40-49', '50-59', '60+'].map((segment, index) => (
          <Line
            key={segment}
            type="monotone"
            dataKey={segment}
            stroke={colors[index]}
            activeDot={{ r: 8 }}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AgeSegmentLineChart;